import {
  POLICY_COMPANIES_PATH,
  POLICY_LIQUIDITY_PATH,
  POLICY_RATINGS_PATH,
} from '../shared/policies.constants';

export const SETTINGS_SECTIONS = [
  { path: POLICY_RATINGS_PATH, labelKey: 'policies.tab.ratings' },
  { path: POLICY_LIQUIDITY_PATH, labelKey: 'policies.tab.liquidity' },
  { path: POLICY_COMPANIES_PATH, labelKey: 'policies.tab.companies' },
] as const;
